// src/components/Experiment/ExportSuggestionDialog.js
import React from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';

const ExportSuggestionDialog = ({
  show,
  onHide,
  onExport,
  exportStatus,
  dataInfo
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi bi-cloud-arrow-up me-2"></i>
          Export Your Data
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="info" className="mb-3">
          <i className="bi bi-info-circle me-2"></i>
          <strong>Data Updated Successfully!</strong>
          <div className="mt-2">
            Your experiment data has been refreshed. Consider exporting it for backup or sharing.
          </div>
        </Alert>

        <div className="mb-3">
          <h6>Current Dataset Summary:</h6>
          <div className="d-flex justify-content-between mb-2">
            <span className="text-muted">Total Rows:</span>
            <span className="fw-bold">{dataInfo.rows || 0}</span>
          </div>
          <div className="d-flex justify-content-between mb-2">
            <span className="text-muted">Total Columns:</span>
            <span className="fw-bold">{dataInfo.columns || 0}</span>
          </div>
          <div className="d-flex justify-content-between">
            <span className="text-muted">Unique Samples:</span>
            <span className="fw-bold">{dataInfo.samples || 0}</span>
          </div>
        </div>

        <p className="text-muted small">
          <i className="bi bi-lightbulb me-1"></i>
          Exporting preserves your current data state, including any manual edits.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-secondary"
          onClick={onHide}
        >
          Skip for Now
        </Button>
        <Button
          variant="primary"
          onClick={onExport}
          disabled={exportStatus === 'exporting'}
        >
          {exportStatus === 'exporting' ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Exporting...
            </>
          ) : (
            <>
              <i className="bi bi-download me-2"></i>
              Export Data Now
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExportSuggestionDialog;